import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Translate, Localize } from "react-redux-i18n";
import styled from "styled-components";
import { getOrders } from "../../Store/Account/Actions";

// region Style
const H5 = styled.h5`
    display: inline;
`;

const Actions = styled.div`
    display: inline;
    float: right;
`;

const Action = styled.span`
    ${Actions} &:first-of-type {
        margin-right: 10px;
    }
`;

const OrderP = styled.p`
    margin-bottom: 0;
`;
// endregion

class CustomerOrders extends Component {
    componentWillMount() {
        const { orders, getOrders } = this.props;

        if (!orders || orders.length === 0) {
            getOrders();
        }
    }

    renderOrders() {
        const { orders } = this.props;

        return _.map(orders, o =>
            <div key={o.id} className="boxed boxed--border bg--secondary">
                <H5><Translate value="profile.orders.orderNumber" />: {o.id}</H5>
                <Actions className="actions">
                    <Action className="action"><Translate value="profile.orders.details" /></Action>
                </Actions>
                <hr/>
                <div className="row">
                    <div className="col-md-12">
                        <OrderP>
                            <Translate value="profile.orders.orderStatus" />: {o.orderStatus}
                        </OrderP>
                        <OrderP>
                            <Translate value="profile.orders.orderDate" />: <Localize value={o.createdOn} dateFormat="locale.date.short" />
                        </OrderP>
                        <OrderP>
                            <Translate value="profile.orders.orderTotal" />: {o.orderTotal}
                        </OrderP>
                        <OrderP>
                            <Translate value="profile.orders.orderRecurringTotal" />: {o.orderRecurringTotal} / <Translate value="misc.month" />
                        </OrderP>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div id="account-billing" className="account-tab">
                <h4><Translate value="profile.orders.title" /></h4>
                {this.renderOrders()}
            </div>
        );
    }
}

CustomerOrders.propTypes = {
    getOrders: PropTypes.func,
    i18n: PropTypes.object,
    config: PropTypes.object,
    orders: PropTypes.array
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        orders: state.orders
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOrders
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrders);
